import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isToday, parseISO } from 'date-fns/esm';
import { Observable } from 'rxjs';
import { StatusParcelaEnum } from 'src/app/shared/enums/status-parcela.enum';
import { StatusLinkPagamentoCelerEnum } from 'src/app/shared/models/pagamento-pix-celer-model';
import { Parcela } from 'src/app/shared/models/parcela.model';

enum StatusParcela {
  PROCESSANDO = 'Processando',
  AGUARDANDO_PAGAMENTO = 'Aguardando Pgto.',
  EM_DIA = 'Em aberto',
  PAGO = 'Pago',
  VENCIDA = 'Atrasada',
  PENDENTE = 'Pendente',
  DUE_TODAY = 'Vence Hoje'
}

@Component({
  selector: 'app-installments-table',
  templateUrl: './installments-table.component.html',
  styleUrls: ['./installments-table.component.scss']
})
export class InstallmentsTableComponent implements OnInit {

  @Output()
  onSelectStallment: EventEmitter<Parcela> = new EventEmitter();

  @Input()
  isInstallmentRenegotiable: boolean;

  @Input()
  installments: Parcela[] = [];

  @Input()
  readOnly: boolean;

  selectedInstallment: Parcela;

  isMobile: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  constructor(
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
  }

  handleChangeSelectedInstallment(installment: Parcela) {
    if (this.allowGenerateSecondCopy(installment)) {
      this.onSelectStallment.emit(installment);
      this.selectedInstallment = installment;
    }
  }

  allowGenerateSecondCopy(parcela: Parcela): boolean {
    const { statusParcela, linkPagamento } = parcela;

    if (this.readOnly) {
      return false;
    }

    if (linkPagamento?.statusLinkPagamento === StatusLinkPagamentoCelerEnum.PAGO) {
      return false;
    }

    if (!this.isInstallmentRenegotiable || statusParcela === StatusParcelaEnum.STATUS_PAGO || statusParcela === StatusParcelaEnum.STATUS_FORA_RANGE_ACORDO) {
      return false;
    }

    return true;
  }

  statusParcelaMap = {
    [StatusParcelaEnum.STATUS_EM_DIA]: StatusParcela.EM_DIA,
    [StatusParcelaEnum.STATUS_PAGO]: StatusParcela.PAGO,
    [StatusParcelaEnum.STATUS_VENCIDA]: StatusParcela.VENCIDA,
    [StatusParcelaEnum.STATUS_ACORDO_RENEGOCIADO]: StatusParcela.VENCIDA,
    [StatusParcelaEnum.STATUS_FORA_RANGE_ACORDO]: StatusParcela.VENCIDA
  };

  statusLinkPagamentoMap = {
    [StatusLinkPagamentoCelerEnum.PAGO]: StatusParcela.PROCESSANDO,
    [StatusLinkPagamentoCelerEnum.AGUARDANDO_PAGAMENTO]: StatusParcela.AGUARDANDO_PAGAMENTO
  };

  getInstallmentStatus(parcela: Parcela): StatusParcela {
    if (this.isParcelBeingProcessed(parcela)) {
      return this.statusLinkPagamentoMap[parcela?.linkPagamento?.statusLinkPagamento]
    }

    if (isToday(parseISO(parcela.dataVencimento))) {
      return StatusParcela.DUE_TODAY;
    }

    return this.statusParcelaMap[parcela.statusParcela] || StatusParcela.PENDENTE;
  }

  statusClassMap = {
    [StatusParcela.PROCESSANDO]: 'processing',
    [StatusParcela.AGUARDANDO_PAGAMENTO]: 'awaiting-payment',
    [StatusParcela.EM_DIA]: 'on-time',
    [StatusParcela.PAGO]: 'paid',
    [StatusParcela.VENCIDA]: 'overdue',
    [StatusParcela.PENDENTE]: 'pending',
    [StatusParcela.DUE_TODAY]: 'due-today'
  };

  getInstallmentStatusClass(status: StatusParcela): string {
    return this.statusClassMap[status];
  }

  getTooltip(status: StatusParcela): string {
    if (status === StatusParcela.AGUARDANDO_PAGAMENTO) {
      return 'Aguardando Pagamento do QRCode';
    }

    if (status === StatusParcela.PROCESSANDO) {
      return 'Pix recebido e aguardando processamento';
    }

    return status;
  }

  isParcelBeingProcessed(parcela: Parcela): boolean {
    const celerStatus = [StatusLinkPagamentoCelerEnum.PAGO, StatusLinkPagamentoCelerEnum.AGUARDANDO_PAGAMENTO];

    return parcela.statusParcela !== StatusParcelaEnum.STATUS_PAGO && celerStatus.includes(parcela?.linkPagamento?.statusLinkPagamento);
  }

}
